(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blass-product-landing"] && !Shopify.designMode) return;
  try {
    
(function(){document.querySelectorAll('[data-section-id]').forEach(function(root){var thumbs=root.querySelectorAll('[data-thumb]');var slides=root.querySelectorAll('[data-slide]');thumbs.forEach(function(btn){btn.addEventListener('click',function(){var idx=btn.getAttribute('data-thumb');thumbs.forEach(function(b){b.classList.remove('is-active')});slides.forEach(function(s){s.classList.remove('is-active')});btn.classList.add('is-active');var slide=root.querySelector('[data-slide="'+idx+'"]');if(slide)slide.classList.add('is-active')})});root.querySelectorAll('.blass-option').forEach(function(group){group.addEventListener('change',function(e){if(e.target.name&&e.target.name.indexOf('options[')===0){group.querySelectorAll('.blass-option__pill').forEach(function(p){p.classList.toggle('is-selected',p.querySelector('input').checked)})}})});root.querySelectorAll('[data-ba]').forEach(function(ba){var clip=ba.querySelector('[data-ba-clip]');var handle=ba.querySelector('[data-ba-handle]');var range=ba.querySelector('[data-ba-range]');if(!clip||!range)return;function update(val){clip.style.width=val+'%';if(handle)handle.style.left=val+'%'}range.addEventListener('input',function(e){update(e.target.value)});update(range.value)})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
